import { indexData } from '@/mocks/homeData';

const colorMap: Record<string, { bg: string; icon: string }> = {
  primary: { bg: 'bg-primary-100', icon: 'text-primary-500' },
  accent: { bg: 'bg-accent-100', icon: 'text-accent-500' },
};

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1280px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-extrabold text-foreground-950 font-heading">{indexData.title}</h2>
          <p className="mt-3 text-foreground-600 text-sm md:text-base">{indexData.subtitle}</p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-3 gap-3 md:gap-4">
          {indexData.items.map((item, i) => {
            const c = colorMap[item.color] || colorMap.primary;
            return (
              <div key={i} className="bg-background-50 rounded-xl p-4 md:p-5 border border-background-200/70 hover:border-primary-200 transition-colors cursor-pointer flex items-center gap-3 md:gap-4">
                <div className={`w-10 h-10 md:w-11 md:h-11 flex items-center justify-center rounded-lg flex-shrink-0 ${c.bg}`}>
                  <i className={`${item.icon} ${c.icon} text-lg md:text-xl`}></i>
                </div>
                <div className="min-w-0">
                  <h3 className="text-sm md:text-base font-bold text-foreground-900 whitespace-nowrap">{item.name}</h3>
                  <p className="text-xs text-foreground-500 mt-0.5">{item.count} 条视频</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}